<template>
  <header class="fixed-header lg-header" v-if="$mq != 'sm'" id="main-nav">
    <nav class="navbar navbar-expand-lg">
      <div class="container">
        <a class="navbar-brand desktop-logo-wrap" href="/">
          <div class="desktop-logo"></div>
          spottySpo
        </a>
        <ul class="navbar-nav ml-auto navbar-md-lg">
          <li class="nav-item" v-if="!current_user.is_guest" style="margin-top: 4px;">
            <a class="btn cta-btn orange btn-small" href="/sport_events/new">
              + {{ I18n.t("sport_events.index.new_button") }}
            </a>
          </li>
          <li class="nav-item">
            <a href="/sport_events" class="nav-link" style="position: relative;">
              <span :class="activeLinkClass('/sport_events')">{{ I18n.t("side_menu.names.events") }}</span>
              <span class="sport-events-notification-counter" v-if="current_user.possible_events_count > 0"></span>
            </a>
          </li>
          <li class="nav-item">
            <a href="/users" class="nav-link">
              <span :class="activeLinkClass('/users')">{{ I18n.t("side_menu.names.users") }}</span>
            </a>
          </li>
          <li class="nav-item messages-link" :class="activeChatLinkClass()" v-if="!current_user.is_guest">
            <a href="/messages" class="nav-link" style="position: relative;">
              <span class="chat-messages-counter" v-if="unreadChatMessagesCount > 0 && !currentPagePath.includes('/messages')">{{ unreadChatMessagesCount }}</span>
              <svg rpl="" fill="currentColor" height="20" icon-name="chat-outline" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.61 19.872a10.013 10.013 0 0 0 6.51-4.035A9.999 9.999 0 0 0 12.275.264c-1.28-.3-2.606-.345-3.903-.132a10.05 10.05 0 0 0-8.25 8.311 9.877 9.877 0 0 0 1.202 6.491l-1.24 4.078a.727.727 0 0 0 .178.721.72.72 0 0 0 .72.19l4.17-1.193A9.87 9.87 0 0 0 9.998 20c.54 0 1.079-.043 1.612-.128ZM1.558 18.458l1.118-3.69-.145-.24A8.647 8.647 0 0 1 1.36 8.634a8.778 8.778 0 0 1 7.21-7.27 8.765 8.765 0 0 1 8.916 3.995 8.748 8.748 0 0 1-2.849 12.09 8.763 8.763 0 0 1-3.22 1.188 8.68 8.68 0 0 1-5.862-1.118l-.232-.138-3.764 1.076ZM6.006 9a1.001 1.001 0 0 0-.708 1.707A1 1 0 1 0 6.006 9Zm4.002 0a1.001 1.001 0 0 0-.195 1.981 1 1 0 1 0 .195-1.98Zm4.003 0a1.001 1.001 0 1 0 0 2.003 1.001 1.001 0 0 0 0-2.003Z"></path>
              </svg>
            </a>
          </li>
          <li class="nav-item" v-if="current_user.is_guest" style="display: flex; align-items: center">
            <a href="/users/sign_in" class="btn cta-btn yellow btn-small">{{ I18n.t("side_menu.names.sign_in") }}</a>
          </li>
          <li class="nav-item" v-if="current_user.is_guest">
            <a href="/users/sign_up" class="nav-link">{{ I18n.t("side_menu.names.sign_up") }}</a>
          </li>
          <li class="nav-item dropdown" v-if="!current_user.is_guest">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <user-avatar :user="current_user" :width="23" :height="23" :online="unopenedNotificationCount > 0" onlineBackgroundColor="red" :onlineWidth="8" :onlineHeight="8" onlinePosition="top" :floatLeft="true" />
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <div class="dropdown-notification-wrap">
                <a class="dropdown-item" href="/notifications">
                  <font-awesome-icon icon="envelope" size="1x" />
                  {{ I18n.t("side_menu.names.notifications") }}
                </a>
                <span class="dropdown-notification-counter" v-if="unopenedNotificationCount > 0">
                  {{ unopenedNotificationCount }}
                </span>
              </div>
              <a class="dropdown-item" href="/users/edit_profile">
                <font-awesome-icon icon="cogs" size="1x" />
                {{ I18n.t("side_menu.names.settings") }}
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="/users/sign_out">
                <font-awesome-icon icon="sign-out-alt" size="1x" />
                {{ I18n.t("side_menu.names.log_out") }}
              </a>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </header>
  <header class="fixed-header mobile-header" v-else-if="side_menu_back_url">
    <div class="container" style="display: flex; align-items: center; position: relative;">
      <div class="back-link">
        <a :href="side_menu_back_url">
          <font-awesome-icon icon="arrow-left" size="lg" />
        </a>
      </div>
      <div style="display: flex; align-items: center; justify-content: center; width: 100%;" v-if="menu_title">
        <div style="font-size: 16px; font-weight: bold;">{{ menu_title }}</div>
      </div>
      <div class="mobile-logo-wrap" v-else>
        <a href="/">
          <div class="mobile-logo"></div>
        </a>
      </div>
    </div>
  </header>
  <header class="fixed-header mobile-header" v-else-if="showMobileHeader">
    <div class="container" style="display: flex; align-items: center; position: relative;">
      <div class="btn-hamburger-wrap" v-if="!chat_layout">
        <div class="btn-hamburger toggle-button"></div>
      </div>
      <span class="notification-counter-hamburger" v-if="!chat_layout && (unopenedNotificationCount > 0 || (current_user.is_guest && current_user.possible_events_count > 0))"></span>
      
      <div>
        <a :href="(side_menu_back_url || '/')" class="back-link" v-if="chat_layout">
          <svg width="9px" height="16px" viewBox="0 0 9 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs></defs>
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Icons" transform="translate(-217.000000, -364.000000)">
                      <g id="Icon/24x24/Arrow-left" transform="translate(194.000000, 360.000000)">
                          <path d="" id="Combined-Shape" stroke="#2D2F33" stroke-width="1"></path>
                          <path d="M7,5 L8,5 L8,6 L7,6 L7,5 Z M6,6 L7,6 L7,7 L6,7 L6,6 Z M5,7 L6,7 L6,8 L5,8 L5,7 Z M4,8 L5,8 L5,9 L4,9 L4,8 Z M3,9 L4,9 L4,10 L3,10 L3,9 Z M2,10 L3,10 L3,11 L2,11 L2,10 Z M1,11 L2,11 L2,12 L1,12 L1,11 Z M2,12 L2,13 L1,13 L1,12 L2,12 Z M3,13 L3,14 L2,14 L2,13 L3,13 Z M4,14 L4,15 L3,15 L3,14 L4,14 Z M5,15 L5,16 L4,16 L4,15 L5,15 Z M6,16 L6,17 L5,17 L5,16 L6,16 Z M7,17 L7,18 L6,18 L6,17 L7,17 Z M8,18 L8,19 L7,19 L7,18 L8,18 Z" id="Combined-Shape" fill="#2D2F33" fill-rule="evenodd"></path>
                      </g>
                      <polygon id="Path-4" fill="#2D2F33" points="224.649994 364.649994 224.304504 364.998749 224 364.998749 224.009186 365.288879 223.301636 365.99942 223.001968 365.99942 223.001968 366.289093 222.295471 367 222 367 222 367.294357 221.302032 368 221.000061 368 221.000061 368.288391 220.297668 368.999664 220 368.999664 220.008133 369.286789 219.297028 370.000275 218.999863 370.000275 218.999863 370.292999 218.289719 371.001312 218.004028 371.001312 218.004028 371.288849 217.30069 371.993088 218.004028 372.704346 218.004028 373.000275 218.289719 373.000275 218.999863 373.706818 218.999863 374.003616 219.297028 374.003616 220.008133 374.714508 220.008133 375.000931 220.297668 375.000931 221.000061 375.709366 221.000061 375.998764 221.302032 375.998764 222.007538 376.710724 222.007538 377.004181 222.295471 377.004181 223.001968 377.707062 223.001968 377.99646 223.301636 377.99646 224 378.701141 224 378.999619 224.285019 378.999619 224.64473 379.347107 225.008133 378.999619 225.355621 378.64621 225 378.304428 225 377.99646 224.710602 377.99646 224 377.303772 224 377.004181 223.712738 377.004181 223.001968 376.293365 223.001968 375.998764 222.706772 375.998764 222 375.295761 222 375.000931 221.714584 375.000931 221.000061 374.292267 221.000061 374.003616 220.707306 374.003616 220 373.291855 220 373.000275 219.714752 373.000275 218.999863 372.288925 218.999863 371.708542 219.714752 371.001312 220 371.001312 220.008133 370.699417 220.707306 370.000275 221.000061 370.000275 221.000061 369.698395 221.714584 368.999664 222 368.999664 222.007538 368.706406 222.706772 368 223.001968 368 223.001968 367.695847 223.712738 366.992737 224 366.992737 224 366.705795 224.710602 365.99942 225 365.99942 225 365.709991 225.355621 365.353943"></polygon>
                  </g>
              </g>
          </svg>
        </a>
      </div>
      
      <div class="mobile-logo-wrap mobile-logo-wrap-left">
        <a href="/">
          <div class="mobile-logo-link-wrap">
            <div class="mobile-logo-sm"></div>
            <div class="mobile-logo-text">spottySpo</div>
          </div>
        </a>
      </div>
      <div :class="newButtonMobileClass()" v-if="!currentPagePath.includes('/messages')"">
        <a href="/sport_events/new" class="btn cta-btn orange btn-small">
          + {{ I18n.t("sport_events.index.new_button") }}
        </a>
      </div>

      <div class="chat-messages-counter-wrap" v-if="showChatMobileButton()">
        <span class="chat-messages-counter" v-if="unreadChatMessagesCount > 0 && !currentPagePath.includes('/messages')">{{ unreadChatMessagesCount }}</span>
        <a href="/messages">
          <span class="chat-messages-counter" v-if="unreadChatMessagesCount > 0 && !currentPagePath.includes('/messages')">{{ unreadChatMessagesCount }}</span>
          <svg rpl="" fill="currentColor" height="20" icon-name="chat-outline" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.61 19.872a10.013 10.013 0 0 0 6.51-4.035A9.999 9.999 0 0 0 12.275.264c-1.28-.3-2.606-.345-3.903-.132a10.05 10.05 0 0 0-8.25 8.311 9.877 9.877 0 0 0 1.202 6.491l-1.24 4.078a.727.727 0 0 0 .178.721.72.72 0 0 0 .72.19l4.17-1.193A9.87 9.87 0 0 0 9.998 20c.54 0 1.079-.043 1.612-.128ZM1.558 18.458l1.118-3.69-.145-.24A8.647 8.647 0 0 1 1.36 8.634a8.778 8.778 0 0 1 7.21-7.27 8.765 8.765 0 0 1 8.916 3.995 8.748 8.748 0 0 1-2.849 12.09 8.763 8.763 0 0 1-3.22 1.188 8.68 8.68 0 0 1-5.862-1.118l-.232-.138-3.764 1.076ZM6.006 9a1.001 1.001 0 0 0-.708 1.707A1 1 0 1 0 6.006 9Zm4.002 0a1.001 1.001 0 0 0-.195 1.981 1 1 0 1 0 .195-1.98Zm4.003 0a1.001 1.001 0 1 0 0 2.003 1.001 1.001 0 0 0 0-2.003Z"></path>
          </svg>  
        </a>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    props: {
      current_user: Object,
      side_menu_back_url: String,
      menu_title: String,
      unread_chat_messages_count: { type: Number, default: 0 },
      chat_layout: { type: Boolean, default: false },
      show_mobile_header: { type: Boolean, default: true }
    },
    data() {
      return {
        unopenedNotificationCount: this.current_user.unopened_notifications_count,
        showMobileHeader: this.show_mobile_header,
        unreadChatMessagesCount: this.unread_chat_messages_count,
        currentPagePath: window.location.pathname
      }
    },
    created() {
      this.$eventHub.$on('skip-mobile-header', () => {
        this.showMobileHeader = false
      })

      this.$eventHub.$on('show-mobile-header', () => {
        this.showMobileHeader = true
      })
    },
    mounted() {
      if(!this.current_user.is_guest) {
        this.$cable.subscribe({ channel: "NotificationHeaderChannel", user_id: this.current_user.id })
      }
    },
    methods: {
      activeLinkClass(pathName) {
        return window.location.pathname === pathName ? 'active-link' : ''
      },
      newButtonMobileClass() {
        return this.showChatMobileButton() ? 'new-circle-wrap' : 'new-circle-wrap-without-chat'
      },
      showChatMobileButton() {
        return !this.current_user.is_guest && !this.currentPagePath.includes('/messages')
      },
      activeChatLinkClass() {
        return window.location.pathname.includes('/messages') ? 'messages-link-active' : ''
      }
    },
    channels: {
      NotificationHeaderChannel: {
        connected() {
          console.log('I am connected to NotificationHeaderChannel.')
        },
        rejected() {},
        received(data) {
          console.log("data received", data)

          if (data.unopened_notifications_count) {
            this.unopenedNotificationCount = data.unopened_notifications_count
          }
        },
        disconnected() {

        }
      }
    },
  }
</script>

<style scoped>
  .lg-header {
    position: sticky;
  }

  .container {
    max-width: 750px;
  }

  .dropdown-menu {
    font-size: 14px;
  }

  .avatar {
    border-radius: 50%;
  }

  .fixed-header {
    height: 55px;
  }

  .notification-counter-hamburger {
    position: absolute;
    top: 16px;
    left: 27px;
    width: 8px;
    height: 8px;

    background-color: rgba(212, 19, 13, 1);
    color: #fff;
    border-radius: 3px;
    padding: 1px 3px;
    font: 8px Verdana;

    @media only screen and (min-width: 650px) and (max-width: 1256px) {
      left: 42px;
    }
  }

  .active-link {
    padding-bottom: 5px;
    border-bottom: 2px solid #7d79b9;
  }

  .desktop-notification-counter {
    position: absolute;
    top: 7px;
    right: 37%;
    background-color: rgba(212, 19, 13, 1);
    color: #fff;
    border-radius: 3px;
    padding: 1px 3px;
    font: 8px Verdana;
    height: 6px;
  }

  .chat-messages-counter {
    position: absolute;
    top: 2px;
    right: 1px;
    background-color: rgba(212, 19, 13, 1);
    font-size: 9px;
    padding: 3px 6px;
    color: white;
    border-radius: 10px;

    @media only screen and (max-width: 768px) {
      right: -9px;
      top: -5px;
    }
  }

  .sport-events-notification-counter {
    position: absolute;
    top: 10px;
    right: 3px;
    background-color: rgba(212, 19, 13, 1);
    height: 6px;
    width: 6px;
    border-radius: 3px;
  }

  .messages-link a:hover {
    background: #e7e7e7;
    border-radius: 20px;
  }

  .messages-link-active {
    background: #e7e7e7;
    border-radius: 20px;
  }

  .dropdown-notification-counter {
    position: absolute;
    top: -3px;
    right: 23px;

    background-color: rgba(212, 19, 13, 1);
    color: #fff;
    border-radius: 3px;
    padding: 1px 3px;
    font: 8px Verdana;
  }

  .dropdown-notification-wrap {
    position: relative;
  }

  .back-link {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 15px;
  }

  .back-link a{
    width: 30px;
    height: 30px;
    margin-top: 15px;
  }

  .mobile-header {
    height: 51px !important;
    display: flex;
  }

  .desktop-logo-wrap, .mobile-logo-link-wrap {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-family: 'Hammersmith One', cursive;
  }

  .desktop-logo {
    background: url("../../images/logo.svg");
    background-repeat: no-repeat;
    width: 40px;
    height: 40px;
  }

  .mobile-logo-wrap {
    position: absolute;
    left: 34%;
  }

  .mobile-logo-sm {
    background: url("../../images/logo.svg");
    background-repeat: no-repeat;
    width: 28px;
    height: 28px;
  }

  .mobile-logo {
    background: url("../../images/logo.svg");
    background-repeat: no-repeat;
    width: 45px;
    height: 45px;
  }

  .mobile-logo-link-wrap {
  }

  .mobile-logo-wrap-left {
    left: 12% !important;
    bottom: 23% !important;

    @media only screen and (min-width: 768px) and (max-width: 1256px) {
      left: 10% !important;
      bottom: 23% !important;
    }
  }

  .mobile-logo-wrap-left a {
    text-decoration: none;
  }

  .mobile-logo-text {
    text-decoration: none;
    padding-top: 3px;
    font-weight: normal;
  }

  .navbar {
    border-bottom: 0;
    box-shadow: none !important;
    padding: 0 20px;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    width: 100%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: justify;
    justify-content: space-between;
    height: 58px;
    font-size: .9em;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transition: 0.2s cubic-bezier(0, 0, 0, 1);
  }

  .navbar-nav {
    flex-direction: row;
    line-height: 1.5;
  }

  .navbar-nav a {
    text-transform: lowercase;
  }

  .nav-item {
    margin-left: 8px;
  }

  .new-circle-wrap {
    bottom: 20%;
    right: 15%;
    position: absolute;
  }

  .new-circle-wrap-without-chat {
    bottom: 20%;
    right: 5%;
    position: absolute;
  }

  .chat-messages-counter-wrap {
    bottom: 30%;
    right: 5%;
    position: absolute;
  }

  .cta-btn.yellow {
    background: #f9db85 !important;
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  .cta-btn.yellow:hover {
    background-color: #f5d270 !important;
  }

  .cta-btn.orange {
    background-color: #f9db85;
    font-weight: 500;
  }

/*  .cta-btn {
    display: inline-block;
    padding: 4px 15px;
    font-size: 18px;
    line-height: 40px;
    min-width: 100px;
  }*/

  .cta-btn.orange:hover {
    background-color: #f7d574;
  }

  .btn-small {
    border: 0px !important;
    font-size: 13px !important;
  }

  .create-btn-wrap {
    position: absolute;
    left: 30%;
  }
</style>
